import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfigureBlockingModalComponent } from 'app/home/paraEmpresas/block/configure/content.component';
import { BlockGroupService } from 'app/services/block.group.service';
import { AlertService } from 'app/utils/alert.service';
import { BindComponentService } from "app/utils/bind.component.service";
import { DataPackGroup } from 'app/models/dataPackGroup.model';
import { DataPackLine } from 'app/models/dataPackLine.model';

import { LoadingComponent } from 'app/home/paraEmpresas/modalLoading/content.component';
  import * as _ from "lodash";
import { PackagesService } from '../../../../services/packages.service';
import { DataBlockVivoUpModalComponent } from './configure/content.component';
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap/accordion/accordion";
/**
 * @version $Id: content.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
@Component({
  selector: 'dataBlockTopUpComponent',
  templateUrl: './content.template.html'
})
export class DataBlockTopUpComponent implements OnInit {
  @Input() private totalGroups:number;



  private static readonly GROUPS_FETCH_SIZE: number = 50;
  private static readonly LINES_FETCH_SIZE: number = 50;
  private static readonly FILTER_ALL_LINES = 'all_lines';
  private static readonly FILTER_BLOCKED_LINES = 'blocked_lines';
  private static readonly FILTER_UNBLOCKED_LINES = 'unblocked_lines';

  public groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public filter: string = DataBlockTopUpComponent.FILTER_ALL_LINES;
  public serviceType: string = DataBlockTopUpComponent.FILTER_ALL_LINES;
  public filterValue: string = '';
  public filteredGroups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public selectedGroup: DataPackGroup;
  public selectedLines: Array<DataPackLine> = new Array<DataPackLine>();
  public groupsFetchSize: number = DataBlockTopUpComponent.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = DataBlockTopUpComponent.LINES_FETCH_SIZE;
  public displayShowMoreGroupsButton: boolean = false;
  public displayShowMoreLinesButton: Map<number, boolean> = new Map<number, boolean>();
  public groupSortingCriteria: string;
  public groupSortingAsc: boolean = true;
  public lineSortingCriteria: string;
  public lineSortingAsc: boolean = true;
  public isloading: boolean = false;
  public page: number;
  public checkAll : boolean;
  private filtered: boolean = false;

  @ViewChild('pageAccordion')
  pageAccordion: NgbAccordion;

  constructor(private modal: NgbModal,
    private packagesService: PackagesService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private bindComponent: BindComponentService) {
  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'BLOCK_VIVO_UP_FILTER'); //ALTERADO
    this.loadView();
  }

  public isSelectLinesAll(){
      return this.checkAll;
  }

  private loadView() {
    //console.log('LoadView'); 
    this.selectedGroup = null;
    this.page = 1;
    this.checkAll = false;
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.serviceType = this.filter;
    this.packagesService.loadViewHiringNow(this.serviceType, 1, DataBlockTopUpComponent.GROUPS_FETCH_SIZE).subscribe(
      data => {
        //console.log(data); 
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        let value : any = data;
        this.setGroups(value, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
    
  }

  ngAfterViewInit() {
    
    this.bindComponent.subscribe(BindComponentService.FILTER_BLOCK,
      group => {
        this.filteredGroups = new Array<DataPackGroup>();
        this.filteredGroups = group;
        this.setGroups(this.filteredGroups, false);
        this.selectedGroup = group;
        this.filtered = true;

      }
    );
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-content-loading',
      size: 'lg',
    });
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
    this.clearSelections();
    this.filterLines();
  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }
    this.filterLines();
  }

 

  public filterLines(filter?: string) {
      this.clearSelections();
      this.filter = filter || this.filter;
      this.filteredGroups = this.groups.filter(group => {

      });
      return true;
  }
  public changePanel(filter?: string) {
      //this.filtered = !this.filtered;
      this.clearSelections();
      this.filter = filter || this.filter;
      this.pageAccordion.activeIds = [];
      this.groups = new Array<DataPackGroup>();
      this.displayShowMoreLinesButton = new Map<number, boolean>();
      this.loadView(); 
      return true;
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private toggleGroup(group: DataPackGroup) {
    if(!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.selectedGroup = group;
      this.page = 1;
    } else {
      this.selectedGroup = null;
    }
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.selectedLines = new Array<DataPackLine>();
  }

  private sortGroups(field: string) {    
    this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
    this.groupSortingCriteria = field;
    this.filteredGroups = _.orderBy(this.filteredGroups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
  }

  private sortLines(field: string) {
    this.lineSortingAsc = this.lineSortingCriteria == field ? !this.lineSortingAsc : true;
    this.lineSortingCriteria = field;
    this.selectedGroup.lines = _.orderBy(this.selectedGroup.lines, [this.lineSortingCriteria], [this.lineSortingAsc ? 'asc' : 'desc']);
  }

  private clearSelections() {
    this.selectedLines = new Array<DataPackLine>();
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.groupSortingCriteria = null;
    this.groupSortingAsc = true;
  }

 
  private selectLine($event, line: DataPackLine) {
    
    if (!_.some(this.selectedLines, line)) {
      this.selectedLines.push(line);
    } else {
      let index = this.selectedLines.indexOf(line);
      this.selectedLines.splice(index, 1);
    }
  }
  


  public isChecked(){
    return false;
  }
  
  private selectAllLines($event) {
    let checked = $event.srcElement.checked;
    if (checked) {
      this.selectedGroup.lines.forEach(line => this.selectedLines.push(line));
     this.checkAll = true;
    } else {
      this.checkAll = false;
      this.selectedLines = new Array<DataPackLine>()
    }
  }

   private showMoreGroups(): void {
    this.packagesService.listGroupsHiring(this.groups.length + 1, this.groupsFetchSize).subscribe(
      data => {
        let dataGroups:any = data;
        this.setGroups(dataGroups, true);
        if (dataGroups.length < this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = false;
        }
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines(): void {

    this.page = this.page + 1;
    this.serviceType = this.filter;
    this.packagesService.listLinesHiringNow(this.selectedGroup, this.serviceType, this.page, this.linesFetchSize).subscribe(
      data => {
        let dataLines:any = data;
        this.setLines(this.selectedGroup, dataLines, true);
        if (dataLines.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton[this.selectedGroup.id] = false;
        }
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private openLiberationModal() {
    if (this.selectedLines.length === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let modalRef = this.modal.open(DataBlockVivoUpModalComponent);
    modalRef.componentInstance.group = this.selectedGroup;
    modalRef.componentInstance.lines = this.selectedLines;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return ''; 
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));  
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } 
    return msisdn;
  }

  public verificarBloqueio(condicao: boolean) {
    return (condicao) ? "Liberado" : "Bloqueado";
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/haring/content.component.ts